import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/changePhone',
    name: 'ChangePhone',
    component: () => import('../views/userInfo/changePhone'),
    meta: {
      background: '#F4F5F6'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/login')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/register')
  },
  {
    path: '/',
    name: 'HomePage',
    component: () => import('../views/homePage')
  },
  {
    path: '/serviceEvaluate',
    name: 'ServiceEvaluate',
    component: () => import('../views/serviceEvaluate'),
    meta: {
      background: '#F4F5F6'
    }
  },
  {
    path: '/openIdPage',
    name: 'OpenIdPage',
    component: () => import('../views/test/openIdPage'),
    meta: {
      background: '#F4F5F6'
    }
  },
  {
    path: '/record',
    name: 'Record',
    component: () => import('../views/checkEvaluate/record'),
    meta: {
      background: '#F4F5F6'
    }
  },
  {
    path: '/QRcode',
    name: 'QRcode',
    component: () => import('../views/QRcode')
  },
  {
    path: '/service',
    name: 'service',
    component: () => import('../views/service')
  },
  {
    path: '/changeDcode',
    name: 'ChangeDcode',
    component: () => import('../views/service/changeDcode')
  },
  {
    path: '/backPage',
    name: 'BackPage',
    component: () => import('../views/backPage'),
    meta: {
      background: '#F4F5F6'
    }
  },
  {
    path: '/test',
    name: 'Test',
    component: () => import('../views/test'),
    meta: {
      background: '#F4F5F6'
    }
  },
  {
    path: '/userInfo',
    name: 'UserInfo',
    component: () => import('../views/userInfo/userinfo')
  },
  {
    path: '/onDcode',
    name: 'OnDcode',
    component: () => import('../views/service/onDcode')
  },
  {
    path: '/equipment',
    name: 'Equipment',
    component: () => import('../views/userInfo/equipment')
  },
  {
    path: '/celerityRepairs',
    name: 'CelerityRepairs',
    component: () => import('../views/celerityRepairs')
  },
  {
    path: '/planParticular',
    name: 'PlanParticular',
    component: () => import('../views/servicePlan/planParticular'),
    meta: {
      background: '#F4F5F6'
    }
  },
  {
    path: '/checkEvaluate',
    name: 'CheckEvaluate',
    component: () => import('../views/checkEvaluate'),
    meta: {
      background: '#F4F5F6'
    }
  },
  {
    path: '/userAgreement',
    name: 'UserAgreement',
    component: () => import('../views/agreement/userAgreement'),
    meta: {
      background: '#F4F5F6'
    }
  },
  {
    path: '/serviceAgreement',
    name: 'ServiceAgreement',
    component: () => import('../views/agreement/serviceAgreement'),
    meta: {
      background: '#F4F5F6'
    }
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
